import { Input, Stack, styled } from '@/theme/index';

export const StyledInput = styled(Input)(() => ({
  paddingY: [1],
  paddingX: [1.5],
}));

export const StyledAddressStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'calc((100% - 20px)/3)',
  },
}));

export const StyledHouseMetaStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'calc(((100% - 40px)/3) * (2/3))',
  },
}));
